import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-faaf380c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "story w1200"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "introduce" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "right" }, [
    /*#__PURE__*/_createTextVNode(" More "),
    /*#__PURE__*/_createElementVNode("div", { class: "more" })
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  class: "h5story",
  style: {"padding-top":"0.28rem"}
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { style: {"display":"flex"} }
const _hoisted_12 = { class: "story_title" }
const _hoisted_13 = { class: "name" }
const _hoisted_14 = { class: "postName" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "h5-content-more" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 查看更多 ")
const _hoisted_18 = {
  class: "single_area",
  style: {"display":"flex"}
}
const _hoisted_19 = { class: "single_story_title" }
const _hoisted_20 = { class: "info" }
const _hoisted_21 = { class: "name" }
const _hoisted_22 = { class: "desc" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "single_more" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 查看更多 ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 查看更多 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_right = _resolveComponent("right")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (!_ctx.$isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_swiper, {
          ref: "mySwiper",
          autoplay: _ctx.swiperOps.autoplay,
          pagination: _ctx.swiperOps.pagination
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storyList, (item, index) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "story-item",
                    onClick: ($event: any) => (_ctx.pushToDetail(item.id))
                  }, [
                    _createElementVNode("div", {
                      class: "bgi",
                      style: _normalizeStyle({ backgroundImage: `url(${item.photoUrl})`, backgroundSize: 'cover' })
                    }, null, 4),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, _toDisplayString(item.name), 1),
                        _createElementVNode("div", null, _toDisplayString(item.realName) + "/" + _toDisplayString(item.realPostName), 1),
                        _createElementVNode("div", {
                          class: "remark",
                          innerHTML: item.remark
                        }, null, 8, _hoisted_5)
                      ]),
                      _hoisted_6
                    ])
                  ], 8, _hoisted_2)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["autoplay", "pagination"]),
        _hoisted_7
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storyList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              style: _normalizeStyle([{ overflow: _ctx.isSingle ? 'hidden' : 'visible' }, {"margin-bottom":"0.28rem"}]),
              key: item.id,
              class: "h5_card",
              onClick: ($event: any) => (_ctx.pushToDetail(item.id))
            }, [
              (!_ctx.isSingle)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: "avatar",
                        style: _normalizeStyle({ backgroundImage: `url(${item.mobilePhotoUrl})`, backgroundSize: 'cover' })
                      }, null, 4),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(item.realName), 1),
                        _createElementVNode("span", _hoisted_14, "（" + _toDisplayString(item.realPostName) + "）", 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "h5content",
                      innerHTML: item.remark
                    }, null, 8, _hoisted_15),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_right)
                        ]),
                        _: 1
                      })
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: "single_avatar",
                        style: _normalizeStyle({ backgroundImage: `url(${item.mobilePhotoUrl})`, backgroundSize: 'cover' })
                      }, null, 4),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, [
                            _createTextVNode(_toDisplayString(item.realName) + " ", 1),
                            _createElementVNode("span", _hoisted_22, "(" + _toDisplayString(item.realPostName) + ")", 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "single_content",
                      innerHTML: item.remark
                    }, null, 8, _hoisted_23),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_right)
                        ]),
                        _: 1
                      })
                    ])
                  ], 64))
            ], 12, _hoisted_10))
          }), 128)),
          (_ctx.h5More)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "h5more",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.more && _ctx.more(...args)))
              }, [
                _hoisted_26,
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_right)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
}